if (!customElements.get('cart-consent')) {
  class CartConsent extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('.js-cart-consent-checkbox');

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.checkbox.addEventListener('change', this.saveConsent.bind(this));

      // Ensure every cart that shows the checkbox has an explicit Yes/No
      // attribute, even if the customer never interacts with it (e.g. they
      // leave via a link that bypasses the cart form submit).
      if (this.dataset.savedValue !== 'Yes' && this.dataset.savedValue !== 'No') {
        this.saveConsent();
      }
    }

    /**
     * Saves the current consent choice as a cart attribute.
     */
    saveConsent() {
      const value = this.checkbox.checked ? 'Yes' : 'No';
      this.dataset.savedValue = value;

      this.fetchRequestOpts.body = JSON.stringify({
        attributes: { 'NFL data sharing consent': value }
      });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-consent', CartConsent);
}
